@if (parsedDate; as date) {
  <div [style.background-image]="'url('+environment.assetsBucketUrl+'/img/calendar.svg)'"
       class="flex flex-col items-center h-full w-12 justify-center bg-center bg-no-repeat text-gray-800">
    <div class="text-base sm:text-lg -mb-1 -mt-1"><strong>{{ date | localizedDate:'dd' }}</strong>
    </div>
    <div class="text-xs -mt-1">{{ date | localizedDate:'MMM' }}</div>
  </div>
}
